import { render } from "./AssetPage.vue?vue&type=template&id=6da02202&scoped=true"
import script from "./AssetPage.vue?vue&type=script&lang=js"
export * from "./AssetPage.vue?vue&type=script&lang=js"

import "./AssetPage.vue?vue&type=style&index=0&id=6da02202&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da02202"]])

export default __exports__